const wrapperCls = "_j0jwjgxt2y";
const buttonCls = "_j0jb1p4mgqe";
const imageWrapperCls = "_j0ji1sp1q4u";
const imageCls = "_j0ji14otd1q";
const infoCircleCls = "_j0ji731oxw";
const textWrapperCls = "_j0jtqrilyz";
const titleCls = "_j0jt867otr";
const metaListCls = "_j0jm1wwrzcq";
const metaItemCls = "_j0jmt82nc5";
const labelCls = "_j0jl1t2u6xe";
const overlayCls = "_j0jozy1r5a";

export { buttonCls, imageCls, imageWrapperCls, infoCircleCls, labelCls, metaItemCls, metaListCls, overlayCls, textWrapperCls, titleCls, wrapperCls };
import "./card.style.linaria.module.css";
//# sourceMappingURL=card.style.js.map
